import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PropType, computed, watch } from "vue";
import { Certificates } from "acquaint-api/models/Certificates";
import { CountryCode } from "bright-logic-core/src/CountryCode";
import EpcInput from "./epc-input.vue";
import BerInput from "./ber-input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'epc-input-wrapper',
  props: {
  /**
   * The value of the component, used with `v-model`.
   * This represents the certificates data being managed.
   * @type {Certificates}
   * @required
   */
  modelValue: {
    type: Object as PropType<Certificates>,
    required: true,
  },

  /**
   * Defines the usage type of the property.
   * This is typically an enumeration or numeric identifier indicating how the property is used.
   * @type {number}
   * @required
   */
  propertyUsage: {
    type: Number,
    required: true,
  },

  /**
   * The country code associated with the property.
   * This should be a numeric code representing a country (e.g., ISO 3166-1 numeric).
   * @type {number}
   * @required
   */
  countryCode: {
    type: Number,
    required: true,
  },

  /**
   * A validation group identifier used for form validation purposes.
   * This helps in grouping fields under a specific validation rule set.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
   * @event update:modelValue
   * @param {Certificates} value - The new value to be updated in the model.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const certificate = computed({
  get: () => props.modelValue,
  set: (value: Certificates) => emit("update:modelValue", value),
});

watch(
  () => props.countryCode,
  () => {
    /* As different countries us the same fields for different information,
     * reset them when the country changes */
    certificate.value.eerCurrent = 0;
    certificate.value.eerCurrentMin = 0;
    certificate.value.eerPotential = 0;
    certificate.value.eerPotentialMin = 0;
    certificate.value.eirCurrent = 0;
    certificate.value.eirCurrentMin = 0;
    certificate.value.eirPotential = 0;
    certificate.value.eirPotentialMin = 0;
  },
);

return (_ctx: any,_cache: any) => {
  return (__props.countryCode == _unref(CountryCode).Ireland)
    ? (_openBlock(), _createBlock(BerInput, {
        key: 0,
        modelValue: certificate.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((certificate).value = $event))
      }, null, 8, ["modelValue"]))
    : (_openBlock(), _createBlock(EpcInput, {
        key: 1,
        modelValue: certificate.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((certificate).value = $event)),
        "property-usage": __props.propertyUsage
      }, null, 8, ["modelValue", "property-usage"]))
}
}

})